{
    "GAME_START_UNIX": "1642708800",
    "GAME_DAY_LENGTH_UNIX": "86400"
}